import type { CSSProperties } from 'react';

export const SHELL_ICON = '/ui/shell-icon.png';

/** Кнопка-«портал» у гру: без тексту GO TO — лише іконка; золотий обідок і градієнт натякають на ігровий перехід. */
export const QUEST_GAME_JUMP_BTN: CSSProperties = {
  borderRadius: 14,
  background: 'linear-gradient(165deg, var(--color-constants-surface) 0%, var(--color-white) 42%, var(--color-constants-surface-2) 100%)',
  border: '2px solid var(--color-accent)',
  boxShadow:
    '0 2px 0 var(--color-warning-deep-alpha-45), 0 8px 20px var(--color-accent-alpha-25), inset 0 1px 0 var(--color-white-alpha-90)',
  padding: '10px 20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  cursor: 'pointer',
  width: '100%',
  minHeight: 52,
  boxSizing: 'border-box',
};

// Окремий Task Ad квест (41) має бути видимий разом з interstitial ad квестом.
export const SHOW_TASK_AD_QUEST_41 = true;

// Глобальна змінна для збереження claimed квестів між переходами (як у progress bar)
// Зберігаємо timestamp, коли квест був claimed, щоб перевіряти, чи не минуло 10 секунд
export const globalClaimedQuestTimestamps = new Map<number, number>(); // userQuestId -> timestamp
export const CLAIMED_QUEST_PROTECTION_MS = 10000; // 10 секунд захисту (більше ніж захист на бекенді 5-10 секунд)
